import React, { useState, useEffect } from 'react';
import { Button, Container } from '@mui/material';
import Select from "react-select";
import { Form, Col, Row, FormControl, InputGroup } from 'react-bootstrap';
import { PuffLoader } from 'react-spinners';
import ReportChart from './ReportChart';
import DatePicker from 'react-datepicker';
import { FaRegCalendarAlt } from "react-icons/fa";
import 'react-datepicker/dist/react-datepicker.css';
import { LiaSearchSolid } from "react-icons/lia";
import Swal from 'sweetalert2';


import "./Report.css";

const Report = () => {
    const [selectCompany, setSelectCompany] = useState(false)
    const [values, setValues] = useState('')
    const [values2, setValues2] = useState('')
    const [values3, setValues3] = useState('')
    const [options2, setOptions2] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    
    useEffect(() => {
        setOptions2([
            { label: "Option 1", value: "option1" },
            { label: "Option 2", value: "option2" }
        ])
    },[])
    useEffect(() => {
        const simulatedDefaultSelectedCompany = sessionStorage.getItem('selected_company');
        if (simulatedDefaultSelectedCompany){
            setValues(options2.find((option) => option.value === simulatedDefaultSelectedCompany))
            setValues2('');
            setValues3(''); 
            const options3 = getCompanyOptions(simulatedDefaultSelectedCompany);
            setCompanyOptions(options3);
        }
    }, [options2]);
    useEffect(() => {
        const simulatedDefaultSelectedCompany2 = sessionStorage.getItem('selected_country');
        if (simulatedDefaultSelectedCompany2){
            setValues2(companyOptions.find((option) => option.value === simulatedDefaultSelectedCompany2))
            const options3 = getLocationOptions(simulatedDefaultSelectedCompany2);
            setLocationOptions(options3);
        }
    }, [values2]);
    useEffect(() => {
        const simulatedDefaultSelectedCompany3 = sessionStorage.getItem('selected_location');
        if (simulatedDefaultSelectedCompany3){
            setValues3(locationOptions.find((option) => option.value === simulatedDefaultSelectedCompany3))
        }
    }, [values3]);
    
    useEffect(() => {
        Swal.fire({
        icon: 'info',
        text: 'We are under maintenance'
        })
        return;
    })
    const handleCompanyChange = (selectedOption) => {
        sessionStorage.setItem('selected_country', '');
        sessionStorage.setItem('selected_location', '');
        setValues3('')
        setValues2('')
        const options3 = getCompanyOptions(selectedOption.value);
        setCompanyOptions(options3);
        sessionStorage.setItem('selected_company', selectedOption.value);
        setValues(options2.find((option) => option.value === selectedOption.value))
    };
    const getCompanyOptions = (countryValue2) => {
        return [
            { label: "Company A (US)", value: "companyA" },
            { label: "Company B (US)", value: "companyB" },
        ];
    };
    const handleLocationChange = (selectedOption) =>{
        setSelectCompany(true)
        sessionStorage.setItem('selected_location', selectedOption.value);
        setValues3(locationOptions.find((option) => option.value === selectedOption.value))
    }
    const getLocationOptions = (countryValue3) => {
      return [
          { label: "Location A (US)", value: "locationA" },
          { label: "Location B (US)", value: "locationB" },
      ];
    };
    const handleCountryChange = (selectedOption) => {
        sessionStorage.setItem('selected_location', '');
        setValues3('')
        const options3 = getLocationOptions(selectedOption.value);
        setLocationOptions(options3);
        setValues2(companyOptions.find((option) => option.value === selectedOption.value))
        sessionStorage.setItem('selected_country', selectedOption.value);
    };
    useEffect(() => {
        const today = new Date();
        setStartDate(today);
        setEndDate(today);
    }, []);

    const handleDateChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };
    
    const maxDate = new Date(); // Today's date
    const calendarStyles = {
        backgroundColor: '#f5f5f5',
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '10px',
        fontFamily: 'sans-serif',
        fontSize: '14px',
      };
    return(
        <div className='body_class'>
        {loading ? (
            <div className="loader-overlay">
                <div className="loader">
                <PuffLoader color="#00308F" loading={true} size={200} />
                </div>
            </div>
        ) : ("")}
            <div className='container-fluid'>
                <>
                <div className='p-1'>
                    <div className='row'>
                        <div className='col-12'>
                        <Form.Group as={Row} className="mt-1" controlId="formPlaintextCountry">
                            <Form.Label column sm="1">Company</Form.Label>
                            <Col sm="3">
                            <Select placeholder="Select Company" options={options2} onChange={handleCompanyChange} value={values}/>
                            </Col>
                            <Form.Label column sm="1">Country</Form.Label>
                            <Col sm="3">
                            <Select placeholder="Select Country" options={companyOptions} onChange={handleCountryChange} value={values2}/>
                            </Col>
                            <Form.Label column sm="1">Location</Form.Label>
                            <Col sm="3">
                            <Select placeholder="Select Location" options={locationOptions} onChange={handleLocationChange} value={values3}/>
                            </Col>
                        </Form.Group>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='row'>
                        <div className='col-4 mt-3 custom_date_reports d-flex'>
                            <FaRegCalendarAlt style={{fontSize:"20px", margin:"4px 4px"}} />
                            <DatePicker
                                selected={startDate}
                                selectsRange
                                startDate={startDate}
                                endDate={endDate}
                                onChange={handleDateChange}
                                dateFormat="MM/dd/yyyy"
                                maxDate={maxDate}
                                monthsShown={2}
                                calendarClassName="custom-calendar"
                                withPortal
                                renderInput={(params) => (
                                    <div className="date-range-text">
                                    <span
                                        onClick={() => {
                                        // Reset to today's date on click
                                        setStartDate(new Date());
                                        setEndDate(new Date());
                                        }}
                                    >
                                        {startDate?.toLocaleDateString() || 'Start Date (click to reset)'}
                                    </span>
                                    {startDate && endDate && (
                                        <span className="date-range-separator">-</span>
                                    )}
                                    <span
                                        onClick={() => {
                                        // Reset to today's date on click
                                        setEndDate(new Date());
                                        }}
                                    >
                                        {endDate?.toLocaleDateString() || 'End Date (click to reset)'}
                                    </span>
                                    </div>
                                )}
                            />
                        </div>
                        <div className='col-2 mt-3'>
                            <Button variant="contained" type="submit">
                                Fetch
                            </Button>
                        </div>
                    </div>
                    <hr />
                    <div className='row'>
                        <div className='col-4'></div>
                        <div className='col-4'></div>
                        <div className='col-4 mt-1'>
                            <InputGroup className="mb-3">
                                <FormControl
                                placeholder="Search (VIN/Vehicle) Number"
                                aria-label="Search"
                                aria-describedby="basic-addon1"
                                />
                                <InputGroup.Text id="basic-addon1" className='seach_icon_report'>
                                    <LiaSearchSolid />
                                </InputGroup.Text>
                            </InputGroup>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='row'>
                      <div className='col-12 col-lg-6 mt-1'>
                        <div style={{border:"1px solid lightgray",boxShadow:"0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1)"}}>
                          <h6 className='p-1'>Driving Distance</h6>
                          <ReportChart mapType="line"/>
                        </div>
                      </div>
                      <div className='col-12 col-lg-6 mt-1'>
                        <div style={{border:"1px solid lightgray",boxShadow:"0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1)"}}>
                          <h6 className='p-1'>Driving Hours</h6>
                          <ReportChart mapType="bar"/>
                        </div>
                      </div>
                      <div className='col-12 col-lg-6 mt-1'>
                        <div style={{border:"1px solid lightgray",boxShadow:"0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1)"}}>
                          <h6 className='p-1'>Fuel Effeiciency</h6>
                          <ReportChart mapType="line"/>
                        </div>
                      </div>
                    </div>
                </div>
                </>
            </div>
        </div>
    )
}

export default Report;